<template>
  <div class="customerBusinessStatisticsCustomerInfo">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.meta.searchText"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div>
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList"
    >
      <div
        class="list-container"
        v-for="(item, index) in tableData"
        :key="index"
      >
        <div class="list-item">
          {{ $t.customerBusinessStatistics.customerNumber }}：{{
            item.CustomerNumber
          }}
        </div>
        <div class="list-item">
          {{ $t.customerBusinessStatistics.companyName }}：{{
            item.CompanyName
          }}
        </div>
        <div class="list-item">
          {{ $t.customerBusinessStatistics.mainWbNumber }}：{{
            item.PWB_Number
          }}
        </div>
        <div class="list-item">
          {{ $t.customerBusinessStatistics.sideWbNumber }}：{{ item.WB_Number }}
        </div>
        <div class="list-item">
          {{ $t.customerBusinessStatistics.financialAccountNo }}：{{
            item.InvoiceNo
          }}
        </div>
        <div class="list-item">
          {{ $t.customerBusinessStatistics.warehouseWorkNumber }}：{{
            item.WarehouseWorkNumber
          }}
        </div>
        <div class="list-item">
          {{ $t.customerBusinessStatistics.createDate }}：{{ item.CreateTime }}
        </div>

        <div
          class="subTotal"
          v-if="item && item.ReceivableAndPayableAmount.length > 0"
        >
          <div class="subTotal-label" v-if="type == 1">
            {{ $t.customerBusinessStatistics.payAmount }}
          </div>
          <div class="subTotal-label" v-if="type == 2">
            {{ $t.customerBusinessStatistics.receivedAmount }}
          </div>
          <div
            class="subTotal-item"
            v-for="(item, index) in item.ReceivableAndPayableAmount"
            :key="index"
          >
            <div class="item1">{{ item.key }}</div>
            <div class="item2">{{ item.value }}</div>
          </div>
        </div>

        <div class="subTotal" v-if="item && item.TotalAmount.length > 0">
          <div class="subTotal-label" v-if="type == 1">
            {{ $t.customerBusinessStatistics.paidTotal }}
          </div>
          <div class="subTotal-label" v-if="type == 2">
            {{ $t.customerBusinessStatistics.receivedTotal }}
          </div>
          <div
            class="subTotal-item"
            v-for="(item, index) in item.TotalAmount"
            :key="index"
          >
            <div class="item1">{{ item.key }}</div>
            <div class="item2">{{ item.value }}</div>
          </div>
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio :name="1">{{
            $t.customerBusinessStatistics.sideWbNumber
          }}</van-radio>
          <van-radio :name="2">{{
            $t.customerBusinessStatistics.warehouseWorkNumber
          }}</van-radio>
          <van-radio :name="3" v-if="type == 1">{{
            $t.customerBusinessStatistics.financialAccountNo
          }}</van-radio>
          <van-radio :name="3" v-if="type == 2">{{
            $t.customerBusinessStatistics.invoiceNo
          }}</van-radio>
        </van-radio-group>

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button
            class="date-btn1"
            type="info"
            size="small"
            @click="showStartDate"
            >{{ $t.meta.beginDate }}</van-button
          >
          <van-button
            class="date-btn2"
            type="info"
            size="small"
            @click="showEndDate"
            >{{ $t.meta.endDate }}</van-button
          >
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>

          <van-popup v-model="showStartPicker" position="bottom">
            <van-datetime-picker
              type="date"
              :title="$t.meta.beginDate"
              :formatter="formatter"
              :confirm-button-text="$t.meta.confirm"
              :cancel-button-text="$t.meta.cancel"
              @confirm="dateChange($event, 'start')"
              @cancel="showStartPicker = false"
              :min-date="currentDate"
            />
          </van-popup>

          <van-popup v-model="showEndPicker" position="bottom">
            <van-datetime-picker
              type="date"
              :title="$t.meta.endDate"
              :formatter="formatter"
              :confirm-button-text="$t.meta.confirm"
              :cancel-button-text="$t.meta.cancel"
              @confirm="dateChange($event, 'end')"
              @cancel="showEndPicker = false"
              :min-date="currentDate"
            />
          </van-popup>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button
          class="reset"
          type="info"
          block
          square
          @click="filterReset"
          >{{ $t.meta.reset }}</van-button
        >

        <van-button
          class="confirm"
          type="primary"
          block
          square
          @click="filterSubmit"
          >{{ $t.meta.confirm }}</van-button
        >
      </div>
    </van-popup>

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
      />
    </van-popup>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  ActionSheet,
  Popup,
  Picker,
  DatetimePicker,
  Radio,
  RadioGroup,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(ActionSheet)
  .use(Popup)
  .use(Picker)
  .use(DatetimePicker)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "customerBusinessStatisticsCustomerInfo",
  data() {
    return {
      customerId: "",
      type: "",
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      showFilter: false,
      //日期
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
    };
  },
  created() {
    const { CustomerId, Type } = this.$route.query;
    this.customerId = CustomerId;
    this.type = Type;
    this.defaultDate();
  },
  methods: {
    defaultDate() {
      let date = new Date();
      let year = date.getFullYear().toString();
      let month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1).toString()
          : (date.getMonth() + 1).toString();
      let da =
        date.getDate() < 10
          ? "0" + date.getDate().toString()
          : date.getDate().toString();
      let end = year + "-" + month + "-" + da;
      let beg = year + "-" + month + "-01";
      this.beginTime = beg;
      this.endTime = end;
    },
    onSearch() {
      this.initList();
      this.getList();
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    filterReset() {
      this.searchText = "";
      this.searchType = null;
      this.beginTime = "";
      this.endTime = "";
      this.defaultDate();
      this.initList();
      this.getList();
    },
    filterSubmit() {
      this.initList();
      this.getList();
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
    },
    getList() {
      var param = {
        CustomerId: this.customerId,
        WB_Number: this.searchType == 1 ? this.searchText : "",
        WarehouseWorkNumber: this.searchType == 2 ? this.searchText : "",
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      var request = null;
      if (this.type == 2) {
        param.InvoiceNo = this.searchType == 3 ? this.searchText : "";
        request =
          this.$api.dataSummary.getCustomerReceivableDetailByCustomerIdAndDate(
            param
          );
      } else {
        param.FinancialAccountNo = this.searchType == 3 ? this.searchText : "";
        request =
          this.$api.dataSummary.getCustomerPaymentDetailByCustomerIdAndDate(
            param
          );
      }
      request
        .then((res) => {
          this.tableData = this.tableData.concat(res.data);
          if (this.tableData.length > 0) {
            for (var item of this.tableData) {
              this.getDic(item);
            }
          }
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    getDic(data) {
      var test = Object.entries(data.ReceivableAndPayableAmountDic);
      var array1 = test.map(([key, value]) => ({
        key,
        value,
      }));
      data.ReceivableAndPayableAmount = array1;

      var test = Object.entries(data.TotalAmountDic);
      var array2 = test.map(([key, value]) => ({
        key,
        value,
      }));
      data.TotalAmount = array2;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.customerBusinessStatisticsCustomerInfo {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
      }
    }
  }
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
      .buttons {
        text-align: right;
        .primary-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-primary;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .default-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-light-gray;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .search-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-green;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
        .danger-btn {
          margin-left: 5px;
          border-radius: 5px;
          background: $-color-red;
          border: none;
          .van-button__text {
            font-size: 14px !important;
          }
        }
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;
      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }
      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }
  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .subTotal {
    margin-bottom: 10px;
    font-size: 12px;
    color: #333333;
    background: #fff;
    .subTotal-label {
      margin-bottom: 10px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      .item1 {
        padding: 5px;
        background: #1e90ff;
        color: #ffffff;
      }
      .item2 {
        padding: 5px;
        background: #e8f4ff;
      }
    }
  }
  .subTotal:last-child {
    margin-bottom: 0px !important;
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    border-top: 1px solid #f6f6f6;
    .tool-button {
      align-items: center;
    }
  }
}
</style>